import React, { useEffect } from 'react';
import { StyledTabSetComponents } from './TabSetComponents.styles';
import Switch from '../Switch';
import Form, { useForm } from '../../molecules/Form';
import Button from '../../molecules/Button';

const EmployeeID = ({ title, data, deviceId, completeData, onSubmit }) => {
  const [form] = useForm();

  const handleSubmit = async e => {
    const payload = {
      id: deviceId,
      configuration: {
        ...completeData?.configuration,
        terminal_configuration: {
          ...completeData?.configuration?.terminal_configuration,
          employee_id: {
            _l: e?.Lock,
            _v: e?.visible,
            value: e?.employeeId,
          },
        },
      },
    };

    onSubmit(payload);
  };

  useEffect(() => {
    form.setFieldsValue({
      visible: data?._v,
      Lock: data?._l,
      employeeId: data?.value,
    });
  }, [data, form]);
  return (
    <StyledTabSetComponents form={form} onSubmit={handleSubmit}>
      <div className="tab-body-header">
        <strong className="title">{title}</strong>
        <div className="switch-wrap">
          <Form.Item label="Visible" name="visible">
            <Switch />
          </Form.Item>
          <Form.Item label="Lock" name="Lock">
            <Switch label="Lock" />
          </Form.Item>
        </div>
      </div>
      <div className="tab-body-body mb">
        <Form.Item label="Disable / Enable" name="employeeId">
          <Switch label="Disable / Enable" />
        </Form.Item>
      </div>
      <div className="submission-wrapper">
        <Button width="140px">Confirm</Button>
      </div>
    </StyledTabSetComponents>
  );
};

export default EmployeeID;
